var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"floorFirst"},[_c('img',{staticClass:"img_cover",attrs:{"src":_vm.kv_image,"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }